const state = () => {
  return {
    menu: [
      {
        icon: "HomeIcon",
        pageName: "LiveG24",
        title: "LiveG24"
      },
      {
        icon: "HomeIcon",
        pageName: "New_Evolution",
        title: "Evolution"
      },
      {
        icon: "HomeIcon",
        pageName: "SA_GAMING",
        title: "SA GAMING"
      },
    ]
  };
};

// getters
const getters = {
  menu: state => state.menu
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
